"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=client-perf.js.map